import * as Yup from "yup";

Yup.setLocale({
  number: {
    min: "Trop court (${min} caractères minimum)",
  },
});

export const yupSelect = Yup.string().required(
  "veuillez selectionner une valeur",
);

export const yupHexacle = Yup.string().matches(
  /^[A-Z0-9\s]+$/,
  "Le format du Code est invalide!",
);

export const yupLatLong = Yup.number().typeError("format: 000.0000000000");
